/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { Component } from 'react';
import {
    object, func, bool, array, string,
} from 'prop-types';
import ReactHtmlParser, { convertNodeToElement } from 'react-html-parser';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Modal from '@material-ui/core/Modal';
import {
    getUserRole,
    getIsAuthenticatedStatus,
} from '../../../../../../../../../state/ducks/Member/ducks/Common/Common-Selectors';
import PassportLearnMoreTnCModal from '../PassportLearnMoreTnCModal/PassportLearnMoreTnCModal';
import { triggerPassportSubscription } from '../../../../../../../../../state/ducks/Passport/Passport-Action';

import {
    getPassportSubscriptionStatus,
    getEspotById,
} from '../../../../../../../../../state/ducks/Common/Common-Selectors';
import { getFlagEnablePassport } from '../../../../../../../../../state/ducks/Passport/Passport-Selectors';
import { getBrand } from '../../../../../../../../../state/ducks/App/ducks/Config/Config-Selectors';

const styles = (theme) => ({
    modalBrackdropProps: {
        backgroundColor: theme.palette.bgPopup,
    },
    overlayContainer: {
        backgroundColor: '#FFF',
        '& h1': {
            fontSize: '20px',
            margin: '20px 0px',
        },
        '& h2': {
            fontSize: '16px',
            margin: '20px 0px',
        },
    },
    wrapModalContent: {
        height: '88%',
        overflow: 'auto',
        position: 'absolute',
        background: '#fff',
        width: '95%',
        margin: '0 auto',
        padding: '5px',
    },
    modelOverflow: {
        overflow: 'auto',
    },
    modalContainer: {
        backgroundColor: theme.palette.grey1,
        padding: '0px 4px',
    },
    headingText: {
        color: theme.palette.white,
        textTransform: 'uppercase',
        fontSize: '16px',
        lineHeight: '48px',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        margin: '0',
        padding: '0 8px',
        fontWeight: 'normal',
    },
    right: {
        right: '10px',
        position: 'absolute',
        fontSize: '20px',
        fontWeight: '100',
        top: '0px',
        padding: '0px 10px',
        textAlign: 'center',
    },
    contentData: {
        margin: '4px',
        fontSize: '0.9em',
        color: theme.palette.black,
        '& > div:first-child': {
            border: '1px solid #cecece',
            margin: '0px',
            borderRadius: '10px',
            overflow: 'hidden',
            '& *': {
                boxSizing: 'border-box',
            },
            '& .pull_left': {
                float: 'left',
            },
            '& .row': {
                position: 'relative',
                margin: '0 10px 20px',
            },
            '& .clear, .row': {
                clear: 'both',
            },
            '& img': {
                width: 'auto',
                display: 'block',
            },
            '& .align_center': {
                textAlign: 'center',
            },
            '& .bold': {
                fontWeight: 'bold !important',
            },
            '& .show': {
                display: 'block !important',
            },
            '& .quarter_margin': {
                marginBottom: '5px !important',
            },
            '& .split': {
                display: '-webkit-box',
            },
            '& .split>*': {
                width: '0',
                position: 'relative',
                marginRight: '10px',
                '-webkitBoxFlex': 1,
                '-webkitFlex': 1,
                boxFlex: 1,
                flex: 1,
            },
            '& .FPassportLogo': {
                '& img': {
                    width: 'auto',
                },
            },
            '& .full_margin_top': {
                marginTop: '20px !important',
            },
            '& .half_margin_top': {
                marginTop: '10px !important',
            },
            '& .pp_section_divider': {
                borderBottom: '1px solid #6ecba6',
                borderTop: '1px solid #6ecba6',
                height: '5px',
                margin: '30px 10px',
            },
            '& .pp_bright_blue': {
                color: '#147a90',
            },
            '& .pp_light_green': {
                color: '#6ecba6',
            },
            '& .small': {
                fontSize: '0.9em !important',
            },
            '& #pass_section1 p a.dec_link_color': {
                textDecoration: 'underline',
                color: '#272727',
            },
            '& #pass_section1_button p.row': {
                fontSize: '1em !important',
                lineHeight: '2em',
                textAlign: 'center',
            },
            '& .addtocart': {
                textDecoration: 'none',
                color: '#FFF',
            },
            '& .FPassportPrice': {
                display: 'inline-block',
                borderRadius: '50% !important',
                background: '#147a90',
                width: '65px',
                height: '65px',
                marginTop: '0',
                '-webkitTransform': 'rotate(13deg)',
                '-mozTransform': 'rotate(13deg)',
                '-msTransform': 'rotate(13deg)',
                '-oTransform': 'rotate(13deg)',
                color: '#ffffff',
                fontFamily: 'Circular-Bold',
                '& .FPOnly': {
                    display: 'block',
                    marginTop: '15px',
                    marginLeft: '16px',
                    textTransform: 'uppercase',
                    lineHeight: '0.5',
                    fontSize: '12px',
                },
                '& .FPDollar': {
                    marginLeft: '8px',
                    fontSize: '12px',
                    verticalAlign: 'text-bottom',
                    marginTop: '18px',
                },
                '& .FPPriceText': {
                    fontSize: '1.4em',
                    position: 'relative',
                },
                '& .FPPriceText1': {
                    verticalAlign: 'top',
                    display: 'inline-block',
                    position: 'absolute',
                    fontSize: '14px',
                    marginTop: '0px',
                    lineHeight: '20px',
                },
                '& .FPYear': {
                    textTransform: 'uppercase',
                    fontSize: '8px',
                    display: 'inline-block',
                    paddingTop: '21px',
                    fontFamily: 'Circular-Light',
                },
                '& span:not(.FPYear)': {
                    fontWeight: 'bold',
                },
            },
            '& .FPLogoContent': {
                marginLeft: '8px',
                fontSize: '22px',
                fontFamily: 'Circular-Bold',
                marginTop: '7px',
                '& .FPCelbText': {
                    display: 'block',
                    lineHeight: '0.3',
                    fontWeight: 'bold',
                    color: '#6ecba6',
                },
                '& .FPPassContent': {
                    fontSize: '32px',
                    lineHeight: '0.8',
                    fontWeight: 'bold',
                    color: '#147a90',
                },
                '& .FPPassR': {
                    display: 'inline-block',
                    lineHeight: '0.3',
                    fontSize: '11px',
                    verticalAlign: 'super',
                    color: '#147a90',
                },
            },
            '& .mobile_brand_log': {
                '& img': {
                    maxWidth: '95%',
                },
                '& .brands_small_row': {
                    width: '80%',
                    margin: '20px auto',
                },
            },
            '& #pass_section1_heading h1': {
                background: 'transparent',
                fontSize: '34px',
                lineHeight: '1.2em',
                textShadow: 'none',
                color: '#147a90',
                textAlign: 'center',
            },
            '& .pass_section1_notanks': {
                textAlign: 'center',
                '& #passport_no_thanks_link': {
                    textDecoration: 'underline',
                    color: '#272727',
                },
            },
            '& .mobile_view_section1': {
                display: 'block',
            },
            '& #pass_section1_heading': {
                '& .desktop': {
                    fontSize: '15px',
                    verticalAlign: 'super',
                },
                '& div.pp_light_green.medium': {
                    fontSize: '0.9em',
                },
            },
            '& #pass_section2': {
                '& ul': {
                    listStyle: 'none',
                    padding: '0',
                },
                '& ul li h3': {
                    fontSize: '1.6em',
                    lineHeight: '1.2',
                    color: '#147a90',
                },
                '& ul li p': {
                    fontSize: '1.2em',
                },
            },
            '& #pass_section3': {
                '& .pp-icon': {
                    display: 'inline',
                },
                '& .extra_width': {
                    margin: '0px 18px',
                },
            },
        },
    },
    btnStyle: {
        borderRadius: '25px',
        textTransform: 'uppercase',
        width: '75%',
        backgroundColor: '#147a90',
        textShadow: '1px 1px 0px #0e5563',
        color: '#fff !important',
        display: 'block',
        textAlign: 'center',
        fontWeight: '600',
        margin: '0 auto',
        padding: '10px',
        textDecoration: 'none',
        fontSize: '1.2em',
    },
    passportAddedText: {
        textAlign: 'center',
        color: '#147a90',
    },
});

class PassportLearnMoreModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tncModalStatus: false,
        };
    }

    handleOpenCloseTncModal = () => {
        this.setState((prevState) => ({ tncModalStatus: !prevState.tncModalStatus }));
    }

    htmlParserTransform = (node, index) => {
        const {
            addPassport, bannerOnPage, history, handleModalClose,
        } = this.props;
        const { classes, isPassportInCart, brandDetails } = this.props;
        if (node.type === 'tag' && node.name === 'span') {
            const { class: elementClass } = node.attribs;
            const passPortPrice = brandDetails['passport-item-price'];
            const passportDurationTextShort = brandDetails['passport-item-duration-short-text'];
            if (passPortPrice
                    && (['FPPriceText', 'FPPriceText1'].indexOf(elementClass) >= 0)
                    && passPortPrice.toString().indexOf('.') > 0) {
                const priceSplit = passPortPrice.toString().split('.');
                if (elementClass === 'FPPriceText') {
                    return (<span key={`${node.name}-${index}`} className={elementClass}>{priceSplit[0]}</span>);
                }
                if (elementClass === 'FPPriceText1') {
                    return (<span key={`${node.name}-${index}`} className={elementClass}>{priceSplit[1]}</span>);
                }
            } else if (passportDurationTextShort && elementClass === 'FPYear') {
                return (<span key={`${node.name}-${index}`} className={elementClass}>/ {passportDurationTextShort}</span>);
            }
        }
        if (node.type === 'tag' && node.name === 'a') {
            const { href, id: elementId, class: elementClass } = node.attribs; // extract the actual url

            if (elementClass === 'addtocart' && !isPassportInCart) {
                return (
                    <div key={`${node.name}-${index}`}>
                        <a
                            id="btnAddPassportToCart"
                            name="btnAddPassportToCart"
                            className={classes.btnStyle}
                            data-testid={`btnAddPassportToCart${index}`} // unit test
                            href="/"
                            onClick={(event) => {
                                event.preventDefault();
                                addPassport(bannerOnPage);
                            }}
                        >
                            {convertNodeToElement(node, index, this.htmlParserTransform)}
                        </a>
                    </div>
                );
            } if (elementClass === 'addtocart' && isPassportInCart) {
                return (
                    <div key={`${node.name}-${index}`}>
                        <h1 className={classes.passportAddedText}>Passport is added to the cart.</h1>
                        <a
                            id="btnContinueToShopping"
                            name="btnContinueToShopping"
                            className={classes.btnStyle}
                            href="/"
                            data-testid={`btnContinueToShopping${index}`} // unit test
                            onClick={(event) => {
                                event.preventDefault();
                                history.push('/');
                            }}
                        >
                            Continue to Shopping
                        </a>
                    </div>
                );
            } if (elementId === 'passport_tnc_link' || href === '/passport-terms-and-conditions-pwa') {
                return (
                    <a
                        key={`${node.name}-${index}`}
                        name="tnc_passport"
                        href={href}
                        data-testid={`tnc_passport${index}`} // unit test
                        onClick={(event) => {
                            event.preventDefault();
                            this.handleOpenCloseTncModal();
                        }}
                    >
                        {convertNodeToElement(node, index, this.htmlParserTransform)}
                    </a>
                );
            } if (elementId === 'passport_no_thanks_link') {
                return (
                    <a
                        key={`${node.name}-${index}`}
                        name="passport_no_thanks_link"
                        data-testid="passport_no_thanks_link" // unit test
                        href={href}
                        onClick={(event) => {
                            event.preventDefault();
                            handleModalClose();
                        }}
                    >
                        {convertNodeToElement(node, index, this.htmlParserTransform)}
                    </a>
                );
            }
            return (
                <a
                    key={`${node.name}-${index}`}
                    href={href}
                >
                    {convertNodeToElement(node, index, this.htmlParserTransform)}
                </a>
            );
        }
        if (node.type === 'tag' && node.name === 'div') {
            const passportDurationTextLong = brandDetails['passport-item-duration-long-text'];
            const { class: elementClass } = node.attribs;
            // TODO - replace the class with an id for exact match
            if (passportDurationTextLong && elementClass === 'row align_center pp_light_green medium bold') {
                return (<div className={elementClass}>{`for ${passportDurationTextLong} from Our Family of Brands.`}</div>);
            }
        }
        return (convertNodeToElement(node, index, this.htmlParserTransform));
    }

    render() {
        const {
            classes,
            handleModalClose,
            contentPassportLearnMore,
            learnMoreModalStatus,
        } = this.props;
        const { tncModalStatus } = this.state;
        let marketingTextHTML = '';
        if (contentPassportLearnMore && contentPassportLearnMore.length > 0) {
            const [learnMoreContent] = contentPassportLearnMore;
            const [baseMarketingSpotActivityData] = learnMoreContent.baseMarketingSpotActivityData;
            const { marketingContentDescription } = baseMarketingSpotActivityData;
            const [contentData] = marketingContentDescription;
            marketingTextHTML = contentData.marketingText;
        }
        // const { modalStatus } = this.state;
        if (marketingTextHTML) {
            return (
                <div>
                    <Modal
                        BackdropProps={{ classes: { root: classes.modalBrackdropProps } }}
                        className={classes.modelOverflow}
                        open={learnMoreModalStatus}
                    >
                        <div className={classes.modalContainer}>
                            <h1 className={classes.headingText}>
                                Celebrations Passport 2
                                <span
                                    className={classes.right}
                                    onClick={() => { handleModalClose(); }}
                                    onKeyDown={() => { }}
                                    role="button"
                                    tabIndex={-1}
                                >
                                    X
                                </span>
                            </h1>
                            <PassportLearnMoreTnCModal modalStatus={tncModalStatus} closeModal={this.handleOpenCloseTncModal} />
                            <div className={classes.overlayContainer}>
                                <div className={classes.wrapModalContent}>
                                    <div className={classes.contentData}>
                                        { ReactHtmlParser(marketingTextHTML, { transform: this.htmlParserTransform }) }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal>
                </div>
            );
        }
        return null;
    }
}

PassportLearnMoreModal.propTypes = {
    contentPassportLearnMore: array,
    classes: object.isRequired,
    addPassport: func.isRequired,
    isPassportInCart: bool.isRequired,
    history: object.isRequired,
    learnMoreModalStatus: bool.isRequired,
    handleModalClose: func.isRequired,
    brandDetails: object,
    bannerOnPage: string,
};

PassportLearnMoreModal.defaultProps = {
    contentPassportLearnMore: [],
    brandDetails: {},
    bannerOnPage: 'product',
};

const mapStateToProps = (state) => ({
    isPassportInCart: getPassportSubscriptionStatus(state),
    userRole: getUserRole(state),
    isAuthenticated: getIsAuthenticatedStatus(state),
    passportFeatureEnabled: getFlagEnablePassport(state),
    contentPassportLearnMore: getEspotById(state, 'CCOPassport_lander-body'),
    brandDetails: getBrand(state),
});

const mapDispatchToProps = (dispatch) => ({
    addPassport: bindActionCreators(triggerPassportSubscription, dispatch),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(PassportLearnMoreModal)));
